import { UpdateLoyaltyProgramState } from './updateLoyaltyProgram.types'

const initialState: UpdateLoyaltyProgramState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
